

export const isOnlyAlphabetNumber = (x) => { // Only alphabet and number, no Punctuation 

    var isValid = true;
    var error  = ''
    if(!x){
        error = "Cannot be empty";
        isValid = false
    }

    if(typeof x !== "undefined" && x !== ''){
        // if(!x.match(/^[a-zA-Z0-9-()]+$/)){
        if(!x.match(/^[a-zA-Z0-9 _.,\-!()+=#]*$/)){
        // if(!x.match(/^[a-zA-Z0-9-_!@#$%^_|]+$/)){            
            error = "Only letters"
            isValid = false
        }     
        // isValid = true   
    }
    console.log(error)
    return isValid
}





